import React from "react";

export default function PanchashilaFrame3({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls-pan31{fill:#e21d27}.cls-pan32{fill:#ba1122}"}</style>
        </defs>
        <path
          d="M1559.54 1687.64H440.46c-108.43 0-196.64-88.21-196.64-196.64V371.93c0-108.43 88.21-196.64 196.64-196.64h1119.08c108.43 0 196.64 88.21 196.64 196.64v1119.08c0 108.43-88.21 196.64-196.64 196.64ZM440.46 211.44c-88.49 0-160.49 71.99-160.49 160.49v1119.08c0 88.49 71.99 160.49 160.49 160.49h1119.08c88.49 0 160.49-71.99 160.49-160.49V371.93c0-88.49-71.99-160.49-160.49-160.49H440.46Z"
          className="cls-pan31"
        />
        <path
          d="M1490.67 1822.88c94.29-107.61 159.16-124.97 202.87-116.95 41.36 7.59 71.82 39.38 131.13 36.39 37.46-1.89 67.66-16.72 87.88-29.52l-11.67-147.6c-23.98 9.18-58.41 17.87-96.11 9.61-41.28-9.04-60.94-32.8-83.32-45.56-37.15-21.19-103.38-24.37-230.93 52.37-11.25 39.64-22.03 97.81-14.6 166.88 3.01 27.97 8.49 52.92 14.76 74.39Z"
          className="cls-pan31"
        />
        <path
          d="M1375.38 1698.65a490.631 490.631 0 0 0 50.87 65.64 490.969 490.969 0 0 0 66.82 60.41c-3.16-17.05-5.99-43.48-.92-75.06a220.148 220.148 0 0 1 25.63-73.23c-47.47 7.41-94.94 14.82-142.4 22.24Z"
          className="cls-pan32"
        />
        <path
          d="M509.33 1822.89c-94.29-107.61-159.16-124.97-202.87-116.95-41.36 7.59-71.82 39.38-131.13 36.39-37.46-1.89-67.66-16.72-87.88-29.52l11.67-147.6c23.98 9.18 58.41 17.87 96.11 9.61 41.28-9.04 60.94-32.8 83.32-45.56 37.15-21.19 103.38-24.37 230.93 52.37 11.25 39.64 22.03 97.81 14.6 166.88a429.073 429.073 0 0 1-14.76 74.39Z"
          className="cls-pan31"
        />
        <path
          d="M624.62 1698.66a490.631 490.631 0 0 1-50.87 65.64 490.969 490.969 0 0 1-66.82 60.41c3.16-17.05 5.99-43.48.92-75.06a220.148 220.148 0 0 0-25.63-73.23c47.47 7.41 94.94 14.82 142.4 22.24Z"
          className="cls-pan32"
        />
        <path
          d="M1517.78 1676.41a2896.704 2896.704 0 0 1-527.17 46.69c-195.42-.62-367.2-20.94-508.79-46.69 6.72-31.03 13.44-62.07 20.17-93.11 6.56-30.29 13.13-60.59 19.68-90.87a2678.503 2678.503 0 0 0 482.59 43.99c176.79.05 332.62-17.42 461.72-39.98l25.32 87.96c8.83 30.67 17.66 61.34 26.48 92.01Z"
          style={{
            fill: "#eae4e4",
          }}
        />
        <path
          d="M1491.3 1584.39a2895.944 2895.944 0 0 1-500.69 42c-186.23-.59-351-19.09-488.62-43.1 6.56-30.29 13.13-60.59 19.68-90.87a2678.503 2678.503 0 0 0 482.59 43.99c176.79.05 332.62-17.42 461.72-39.98l25.32 87.96Z"
          className="cls-pan31"
        />
        {children}
      </g>
    </svg>
  );
}
